import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import getters from './getter'
import tagsView from './modules/tagsView'
import common from './modules/common'
import cloneDeep from 'lodash/cloneDeep'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    app,
    tagsView,
    common
  },
  // mutations: {
  //   // 重置vuex本地储存状态
  //   resetStore (state) {
  //     Object.keys(state).forEach((key) => {
  //       state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
  //     })
  //   }
  // },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js